"use client";

import { MapFormDialog } from "@components/blocks/mapForm/MapFormDialog";
import { useSearchParams } from "next/navigation";

import Map from "../../blocks/map/map";
import MapForm from "../../blocks/mapForm/MapForm";
import { DownloadDialog } from "./downloadDialog/DownloadDialog";
import { useMapSectionData } from "./useMapSectionData";

export function MapSection() {
  const { filters, paths, facilities, poi } = useMapSectionData();
  const searchParams = useSearchParams();
  const type = searchParams.get("type");

  return (
    <section className="bg-accent">
      <div className="relative flex h-full max-h-screen overflow-hidden">
        <aside className="hidden h-screen max-h-screen w-[330px] overflow-hidden bg-white px-5 pr-0 md:block">
          <MapForm filters={filters} results={facilities.length} />
        </aside>
        <MapFormDialog filters={filters} facilitiesLength={facilities.length} />
        <Map facilities={facilities} paths={paths} poi={poi} type={type} />
        <div className="absolute bottom-0 right-0 z-50 w-full  md:right-10 md:w-[300px]">
          <DownloadDialog />
        </div>
      </div>
    </section>
  );
}
